const detailsButton = document.getElementById("product-details-btn");
const overlay = document.getElementById("product-details-overlay");
const closeButton = overlay.querySelector(".js-modal-close");

detailsButton.addEventListener("click", function () {
  overlay.classList.add("show");
  const fixedButton = document.querySelector(".product-form__buttons");
  const overlayContent = document.querySelector(".overlay-content");
  const fixedButtonHeight = fixedButton.offsetHeight;
  overlayContent.style.paddingBottom = `${fixedButtonHeight}px`;
  document.body.classList.add("overflow-hidden");
});

overlay.addEventListener("click", function (event) {
  if (!event.target.closest(".overlay-content")) {
    overlay.classList.remove("show");
    document.body.classList.remove("overflow-hidden");
  }
});

closeButton.addEventListener("click", function (event) {
  overlay.classList.remove("show");
  document.body.classList.remove("overflow-hidden");
})
